
import React from "react"
import "../index.css"
import ButtonBlack from "../../../../components/Buttons/ButtonBlack"
import cursor from "../../../assets/icons/Cursor_simple_flat_icon_vector_illustration-removebg-preview.png"
import ButtonHoverAnimated from "../../../../components/Buttons/ButtonHoverAnimated"
import { useNavigate } from "react-router-dom"


const TrainingCategories =()=>{
        const navigate = useNavigate()
    
    return(
        <div className=" gap-4 p-responsive py-10 md:py-20  grid grid-cols-1 md:grid-cols-2 w-full overflow-hidden">
      
      {/* Left Section - Text Content */}
      <div className="flex flex-col justify-center items-start space-y-8">
                <p className='text-lg font-semibold bg-primary-green px-2 py-1 rounded text-start'>Développez vos compétences</p>
                <div className="space-y-8">
                    <h2 className="text-4xl font-bold leading-relaxed flex items-start"> 
                        Explorez des formations de qualité 
                        <img src={cursor} alt="cursor" className="size-24 ml-4" />
                    </h2>
                    <p className='text-lg leading-relaxed text-start'>
                        Trouvez des cours adaptés à votre carrière et des mentors prêts à vous guider. 
                        Notre plateforme met en relation étudiants et professionnels pour assurer votre réussite.
                    </p>
                    <div className='justify-start flex'>
                    <ButtonHoverAnimated onClick={()=>navigate("formation")} path='/formation' className=" text-base px-6 py-2 rounded-sm border-2 border-primary-black ">Explorer les formations</ButtonHoverAnimated>
                        {/* <ButtonBlack DefaultClassName="px-8 py-4 text-lg rounded-md">
                            Explorer les formations
                        </ButtonBlack> */}
                    </div>
                </div>
            </div>

        <div className="rounded-md overflow-hidden bg-neutral-800 h-[450px] -pt-20">
        <div class="wrapper">
                <div class="itemLeft item1"></div>
                <div class="itemLeft item2"></div>
                <div class="itemLeft item3"></div>
                <div class="itemLeft item4"></div>
                <div class="itemLeft item5"></div>
                <div class="itemLeft item6"></div>
                <div class="itemLeft item7"></div>
                <div class="itemLeft item8"></div>
            </div>
            <div class="wrapper">
                <div class="itemRight item1">Hello</div>
                <div class="itemRight item2"></div>
                <div class="itemRight item3"></div>
                <div class="itemRight item4"></div>
                <div class="itemRight item5"></div>
                <div class="itemRight item6"></div>
                <div class="itemRight item7"></div>
                <div class="itemRight item8"></div>
            </div>
            <div class="wrapper">
                <div class="itemLeft item1"></div>
                <div class="itemLeft item2"></div>
                <div class="itemLeft item3"></div>
                <div class="itemLeft item4"></div>
                <div class="itemLeft item5"></div>
                <div class="itemLeft item6"></div>
                <div class="itemLeft item7"></div>
                <div class="itemLeft item8"></div>
            </div>
            <div class="wrapper">
                <div class="itemRight item1"></div>
                <div class="itemRight item2"></div>
                <div class="itemRight item3"></div>
                <div class="itemRight item4"></div>
                <div class="itemRight item5"></div>
                <div class="itemRight item6"></div>
                <div class="itemRight item7"></div>
                <div class="itemRight item8"></div>
            </div>
            <div class="wrapper">
                <div class="itemLeft item1"></div>
                <div class="itemLeft item2"></div>
                <div class="itemLeft item3"></div>
                <div class="itemLeft item4"></div>
                <div class="itemLeft item5"></div>
                <div class="itemLeft item6"></div>
                <div class="itemLeft item7"></div>
                <div class="itemLeft item8"></div>
            </div>
            <div class="wrapper">
                <div class="itemRight item1"></div>
                <div class="itemRight item2"></div>
                <div class="itemRight item3"></div>
                <div class="itemRight item4"></div>
                <div class="itemRight item5"></div>
                <div class="itemRight item6"></div>
                <div class="itemRight item7"></div>
                <div class="itemRight item8"></div>
            </div>
            <div class="wrapper">
                <div class="itemLeft item1"></div>
                <div class="itemLeft item2"></div>
                <div class="itemLeft item3"></div>
                <div class="itemLeft item4"></div>
                <div class="itemLeft item5"></div>
                <div class="itemLeft item6"></div>
                <div class="itemLeft item7"></div>
                <div class="itemLeft item8"></div>
            </div>
            <div class="wrapper">
                <div class="itemRight item1"></div>
                <div class="itemRight item2"></div>
                <div class="itemRight item3"></div>
                <div class="itemRight item4"></div>
                <div class="itemRight item5"></div>
                <div class="itemRight item6"></div>
                <div class="itemRight item7"></div>
                <div class="itemRight item8"></div>
            </div>
        </div>

       
        </div>
    )
}

export default TrainingCategories